/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TemplateQuestionsControllerCreateMutationRequest, TemplateQuestionsControllerCreateMutationResponse, TemplateQuestionsControllerCreate400, TemplateQuestionsControllerCreate401, TemplateQuestionsControllerCreate403 } from "../../models/checklistsController/TemplateQuestionsControllerCreate";

function getTemplateQuestionsControllerCreateUrl() {
  const res = { method: 'POST', url: `/api/v1/checklist-template-questions` as const }  
  return res
}

/**
 * @summary Create a new checklist template question
 * {@link /api/v1/checklist-template-questions}
 */
export async function templateQuestionsControllerCreate(data?: TemplateQuestionsControllerCreateMutationRequest, config: Partial<RequestConfig<TemplateQuestionsControllerCreateMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<TemplateQuestionsControllerCreateMutationResponse, ResponseErrorConfig<TemplateQuestionsControllerCreate400 | TemplateQuestionsControllerCreate401 | TemplateQuestionsControllerCreate403>, TemplateQuestionsControllerCreateMutationRequest>({ method : "POST", url : getTemplateQuestionsControllerCreateUrl().url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}